module.exports = __webpack_public_path__ + "img/colored-test.ccd77348.png";